// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-range__track--active {
  background-color: #a046d3;
}

.input-range__slider {
  background-color: #a046d3;
  border: 1px solid #a046d3;
  background-clip: content-box;
}

.min100 {
  min-width: 150px;
}

.input-range-container {
  position: relative;
}

.labels {
  width: 100%;
  top: -20px;
  display: flex;
  justify-content: space-between;
}

.upper-label {
  position: absolute;
  transform: translateX(-50%);
  white-space: nowrap;
  top: -20px;
}

.lower-label {
  position: absolute;
  transform: translateX(-50%);
  white-space: nowrap;
  top: -5px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/table/Tables/components/tables-filter.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;AACX","sourcesContent":[".input-range__track--active {\n  background-color: #a046d3;\n}\n\n.input-range__slider {\n  background-color: #a046d3;\n  border: 1px solid #a046d3;\n  background-clip: content-box;\n}\n\n.min100 {\n  min-width: 150px;\n}\n\n.input-range-container {\n  position: relative;\n}\n\n.labels {\n  width: 100%;\n  top: -20px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.upper-label {\n  position: absolute;\n  transform: translateX(-50%);\n  white-space: nowrap;\n  top: -20px;\n}\n\n.lower-label {\n  position: absolute;\n  transform: translateX(-50%);\n  white-space: nowrap;\n  top: -5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
